import { Alert } from "@mui/material";
import { Trans } from "react-i18next";
import { DotLegalCheckbox, DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import HighlightedName from "@common/components/HighlightedName";
import PaneLayout from "../../../main/panes/paneLayout/PaneLayout";
import { definePane } from "../../../main/panes/definePane";
import { useChangeAdditionalRecipientsPane } from "./ChangeAdditionalRecipientsPane.hooks";
import { ChangeAdditionalRecipientsPaneProps } from "./ChangeAdditionalRecipientsPane.types";

function ChangeAdditionalRecipientsPane(props: ChangeAdditionalRecipientsPaneProps) {
    const { translateString } = useTranslation();
    const { saveModel, modelUpdater, additionalRecipientOptions, hasRemovedAdditionalRecipients, isLoadingContacts, onSaveClick, isSaving } =
        useChangeAdditionalRecipientsPane(props);

    return (
        <PaneLayout header={translateString("changeAdditionalRecipients")} okButtonText={translateString("save")} onOkClick={onSaveClick} inProgress={isSaving}>
            <Alert severity={"info"} sx={{ marginBottom: 2 }}>
                <Trans
                    i18nKey={"changeAdditionalRecipientsDescription"}
                    values={{ audit: props.questionnaireName }}
                    components={{ strong: <HighlightedName /> }}
                />
            </Alert>

            <DotLegalMultiSelect
                options={additionalRecipientOptions}
                chosenOptions={saveModel.contactIds}
                onChange={modelUpdater.onContactIdsChange}
                label={translateString("additionalRecipients")}
                noOptionsLabel={translateString("noOptions")}
                isLoading={isLoadingContacts}
            />

            {hasRemovedAdditionalRecipients && (
                <DotLegalCheckbox
                    checked={saveModel.revokeAccessForRemovedRecipients}
                    onChange={modelUpdater.onRevokeAccessForRemovedRecipientsChange}
                    label={translateString("revokeAccessForRemovedRecipients")}
                    tooltip={translateString("revokeAccessForRemovedRecipientsInfo")}
                />
            )}
        </PaneLayout>
    );
}

export default definePane({ slot: "right", component: ChangeAdditionalRecipientsPane });
